export default "__VITE_ASSET__5zLNi4cK__"